import Vue from 'vue'
import { get, findIndex } from 'lodash'

Vue.prototype.$lodash = {
  get,
  findIndex,
}
